/**
 * @generated SignedSource<<ae2281f33b4cabcb5790bb7495cc5807>>
 * @relayHash 742eee83cdd53782644c0f1c7104c2b7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 26ce543e87ffebecace140f00ed9a0c86cfd997c44cd744ce16913d2a8509bff

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CardCoverManagerQuery } from './CardCoverManagerQuery.graphql';

const node: PreloadableConcreteRequest<CardCoverManagerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "26ce543e87ffebecace140f00ed9a0c86cfd997c44cd744ce16913d2a8509bff",
    "metadata": {},
    "name": "CardCoverManagerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
